import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
    tunnel: '/api/sentry-tunnel',
  });
  window.Sentry = Sentry;
  window.__checkSentry__ = function () {
    Sentry.captureMessage('Frontend Sentry check', 'info');
    return 'Событие отправлено в Sentry. Проверьте проект в Sentry.';
  };

  // Resource load errors (404 on script/link/img) — no event.error, only event.target
  window.addEventListener(
    'error',
    (event) => {
      const target = event.target;
      if (
        target &&
        (target.tagName === 'SCRIPT' || target.tagName === 'LINK' || target.tagName === 'IMG') &&
        !event.error
      ) {
        const tag = target.tagName.toLowerCase();
        const href = target.src || target.href || '(unknown)';
        Sentry.withScope((scope) => {
          scope.setTag('resource_type', tag);
          scope.setExtra('url', href);
          Sentry.captureMessage(`Resource load failed: ${tag} ${href}`, 'warning');
        });
      }
    },
    true
  );
} else {
  window.__checkSentry__ = function () {
    return 'Sentry не инициализирован: в бандле нет DSN (проверьте сборку с REACT_APP_SENTRY_DSN).';
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

if (sentryDsn) {
  root.render(
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: 24, textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <pre style={{ textAlign: 'left', overflow: 'auto' }}>{error?.message}</pre>
          <button type="button" onClick={resetError}>Try again</button>
        </div>
      )}
    >
      {app}
    </Sentry.ErrorBoundary>
  );
} else {
  root.render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
